export default "__VITE_ASSET__QGtmdcgURqKjdOOnY2Ga$A__"